import getProjectInvoices from "./getProjectInvoices";
import updateProjectInvoice from "./updateProjectInvoice";
import createProjectInvoice from "./createProjectInvoice";
import deleteProjectInvoice from "./deleteProjectInvoice";

export { getProjectInvoices, updateProjectInvoice, createProjectInvoice, deleteProjectInvoice };

export default { getProjectInvoices, updateProjectInvoice, createProjectInvoice, deleteProjectInvoice };